export function get90DaysAgoMidnight(timestamp = 0, days = 89) {
    const now = timestamp ? new Date(timestamp) : new Date();
    const year = now.getFullYear();
    const month = `${now.getMonth() + 1}`.padStart(2, '0');
    const day = `${now.getDate()}`.padStart(2, '0');
    const todayMidnight = new Date(`${year}-${month}-${day}T00:00:00`).getTime();
    return todayMidnight - days * 24 * 60 * 60 * 1000;
}
export function isSameMinute(time1, time2) {
    if (!time1 || !time2) {
        return false;
    }
    const minute1 = Math.floor(time1 / 1000 / 60);
    const minute2 = Math.floor(time2 / 1000 / 60);
    return minute1 === minute2;
}
export function getFormatDate(timestamp = Date.now(), { needSpecial = false, nowTimestamp = Date.now() } = {}) {
    try {
        const date = new Date(+timestamp);
        const weekDays = [
            '星期日',
            '星期一',
            '星期二',
            '星期三',
            '星期四',
            '星期五',
            '星期六'
        ];
        const weekDay = weekDays[date.getDay()];
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        let config = {};
        if (needSpecial) {
            const now = new Date(nowTimestamp);
            const yesterday = now;
            yesterday.setDate(now.getDate() - 1);
            config = {
                isToday: date.toDateString() === now.toDateString(),
                isYesterDay: date.toDateString() === yesterday.toDateString(),
                isSameYear: date.getFullYear() === now.getFullYear()
            };
        }
        return {
            weekDay,
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
            ...config
        };
    }
    catch (e) {
        console.warn('getFormatDate got something wrong.');
        return {};
    }
}
export function getGreeting(timestamp = Date.now()) {
    const date = new Date(+timestamp);
    const hours = date.getHours();
    if (hours >= 4 && hours <= 8) {
        return '早上好';
    }
    else if (hours > 8 && hours <= 10) {
        return '上午好';
    }
    else if (hours > 10 && hours <= 12) {
        return '中午好';
    }
    else if (hours > 12 && hours <= 17) {
        return '下午好';
    }
    else if (hours > 17 && hours <= 21) {
        return '晚上好';
    }
    else {
        return '夜已深';
    }
}
